import {
  AutomationKindType,
  type CreateAutomationInputType,
} from "@/types/graphql/partner.generated";

/** Виды, которые создаёт диалог создания (рассылки живут на своей странице). */
export type CreateKind =
  | AutomationKindType.PlatformEventType
  | AutomationKindType.JourneyType;

/** Имя нового сценария по виду; у шаблона имя ставит сервер. */
export const BLANK_NAME_KEYS: Record<CreateKind, string> = {
  [AutomationKindType.PlatformEventType]: "automations.create.blankName",
  [AutomationKindType.JourneyType]: "automations.create.blankJourneyName",
};

/** Вход createAutomation для выбранного варианта диалога создания. */
export function createAutomationInput(
  choice: { kind: CreateKind; templateKey: string | null },
  t: (key: string) => string
): CreateAutomationInputType {
  return {
    name: t(BLANK_NAME_KEYS[choice.kind]),
    kind: choice.kind,
    templateKey: choice.templateKey,
  };
}
